// Due to URL size limitations, the maximum number of shareable products is capped at 640.
export const MAX_SHAREABLE_PRODUCTS = 640;